import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import apolloClient from '@/apollo.config.js';

Vue.use(VueApollo);

export default new ApolloClient(apolloClient());
